import Flower from "./flower.png";
import "./index.scss";
import { laterInformationModal } from "@apis/hooks";
import { IconErrorRed, IconSuccessGreen } from "@icons/index";
import { getTikTokImg } from "@utils/util";
import { useRef, useState } from "react";
import { Trans } from "react-i18next";

export const ModalErrorTip = ({ title, subtitle }: { title: string; subtitle?: string }) => {
  return (
    <div className="Component_ModalErrorTip Component_Modal_Bg">
      <div className="Modal_container">
        <IconErrorRed className="text-kds-danger-fg"></IconErrorRed>
        <div className="right_text">
          <span className="title">
            <Trans>{title}</Trans>
          </span>
          {subtitle && (
            <div className="subtitle">
              <Trans>{subtitle}</Trans>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const ModalIdentityInfo = ({ title, username, url }: { title: string; username?: string; url?: string }) => {
  return (
    <div className="Component_ModalIdentityInfo Component_Modal_Bg">
      <div className="Modal_container">
        <div className="userAvator">
          <div className="userImg_wrapper">
            <img className="userImg" src={getTikTokImg(url || "default.jpg")} alt="" />
          </div>
          <IconSuccessGreen className="success_icon"></IconSuccessGreen>
        </div>
        <div className="username">
          <Trans>@{username || "Gasstat"}</Trans>
        </div>
        <div className="title">
          <Trans>{title}</Trans>
        </div>
      </div>
    </div>
  );
};

export const ModalAuthorizion = ({
  title,
  subtitle,
  onClick,
}: {
  title: string;
  subtitle?: string;
  onClick?: Function;
}) => {
  return (
    <div className="Component_ModalAuthorizion Component_Modal_Bg">
      <div className="Modal_container">
        <div className="Component_ModalAuthorizion_img_wrapper">
          <img className="modal_img" src={Flower} alt="" />
        </div>
        <div className="title">
          <Trans>{title}</Trans>
        </div>
        <div className="subtitle">
          <Trans>{subtitle}</Trans>
        </div>
        <div className="confirm" onClick={() => onClick?.()}>
          <Trans>Confirmed</Trans>
        </div>
      </div>
    </div>
  );
};

export const useModalTip = ({
  type,
  title,
  subtitle,
  url,
  username,
}: {
  type: "error" | "info" | "confirm";
  title?: string;
  subtitle?: string;
  url?: string;
  username?: string;
}) => {
  const [visible, setVisible] = useState(false);
  const infoRef = useRef<any>({});
  const showDom = () => {
    if (visible) {
      if (type !== "confirm") {
        setTimeout(() => {
          setVisible(false);
          sessionStorage.removeItem("showTikTokInfo");
          laterInformationModal();
        }, 1500);
      }
      const finType = (infoRef.current.type || type) as "error" | "info" | "confirm";
      return {
        error: (
          <ModalErrorTip
            title={infoRef.current.title || title}
            subtitle={infoRef.current.subtitle || subtitle}
          ></ModalErrorTip>
        ),
        info: (
          <ModalIdentityInfo
            title={infoRef.current.title || title}
            url={infoRef.current.url || url}
            username={infoRef.current.username || username}
          ></ModalIdentityInfo>
        ),
        confirm: (
          <ModalAuthorizion
            title={infoRef.current.title || title}
            subtitle={infoRef.current.subtitle || subtitle}
            onClick={() => setVisible(false)}
          ></ModalAuthorizion>
        ),
      }[finType];
    } else {
      return <></>;
    }
  };
  return {
    showDom,
    open: (info?: { username?: string; url?: string; subtitle?: string; title?: string; type?: string }) => {
      infoRef.current = info;
      setVisible(true);
    },
  };
};
